export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["UPDATE_VALUE"] = "UPDATE_VALUE";
    ActionTypes["TOGGLE_DROPDOWN"] = "TOGGLE_DROPDOWN";
    ActionTypes["UPDATE_SELECTED_COUNTRY"] = "UPDATE_SELECTED_COUNTRY";
    ActionTypes["ON_FOCUS_INPUT"] = "ON_FOCUS_INPUT";
    ActionTypes["ON_BLUR_INPUT"] = "ON_BLUR_INPUT";
    ActionTypes["UPDATE_FOCUS_INPUT"] = "UPDATE_FOCUS_INPUT";
})(ActionTypes || (ActionTypes = {}));
export function updateValue(_a) {
    var localPhoneNumber = _a.localPhoneNumber, countryPhoneCode = _a.countryPhoneCode, selectedCountry = _a.selectedCountry;
    return {
        type: ActionTypes.UPDATE_VALUE,
        localPhoneNumber: localPhoneNumber,
        countryPhoneCode: countryPhoneCode,
        selectedCountry: selectedCountry,
    };
}
export function toggleDropDown(open) {
    return {
        type: ActionTypes.TOGGLE_DROPDOWN,
        open: open,
    };
}
export function updateSelectedCountry(selectedCountry) {
    return {
        type: ActionTypes.UPDATE_SELECTED_COUNTRY,
        selectedCountry: selectedCountry,
    };
}
export function onFocusInput() {
    return {
        type: ActionTypes.ON_FOCUS_INPUT,
    };
}
export function onBlurInput() {
    return {
        type: ActionTypes.ON_BLUR_INPUT,
    };
}
export function updateFocusInput(focusInput) {
    return {
        type: ActionTypes.UPDATE_FOCUS_INPUT,
        focusInput: focusInput,
    };
}
//# sourceMappingURL=actions.js.map